import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import '../../services/GlobalVariables'
import axios from 'axios'

const API_URL = global.SET_API_URL + 'itemHeads/'

const initialState = {
    heads: [],
    headSetupData: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: ""
}

export const getHeadSetupData = createAsyncThunk('itemhead/ghsd', async (_, thunkAPI) => {
    try {
        const result = await axios.get(API_URL + 'getHeadSetupData')
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const addNewItem = createAsyncThunk('itemhead/anh', async (headData, thunkAPI) => {
    try {
        await axios.post(API_URL + 'addNewHead', headData)
        return headData
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const getAllIHeads = createAsyncThunk('itemhead/gah', async (_, thunkAPI) => {
    try {
        const result = await axios.get(API_URL + 'getAllHeads')
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const deleteHead = createAsyncThunk('itemhead/dh', async (itemCode, thunkAPI) => {
    try {
        const result = await axios.post(API_URL + 'deleteHead', itemCode)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const itemsHeadsSlice = createSlice({
    name: 'menus',
    initialState,
    reducers: {
        reset: (state) => {
            state.heads = []
            state.isLoading = false
            state.isError = false
            state.isSuccess = false
            state.message = ""
        }

    },
    extraReducers: (builder) => {
        builder
            .addCase(getHeadSetupData.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getHeadSetupData.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.headSetupData = action.payload
            })
            .addCase(getHeadSetupData.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
            .addCase(addNewItem.pending, (state) => {
                state.isLoading = true
            })
            .addCase(addNewItem.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.heads.push(action.payload)
            })
            .addCase(addNewItem.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
            .addCase(getAllIHeads.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getAllIHeads.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.heads = action.payload
            })
            .addCase(getAllIHeads.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
    }
})

export const { reset } = itemsHeadsSlice.actions

export default itemsHeadsSlice.reducer